import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { PolicyService } from './policy.service';

@NgModule({
    imports: [CommonModule],
})
export class SharedPolicyModule {
    public static forRoot(): ModuleWithProviders<SharedPolicyModule> {
        return {
            ngModule: SharedPolicyModule,
            providers: [PolicyService],
        };
    }
}
